import React, { Fragment } from 'react'

import { Link } from 'react-router-dom'

import PropTypes from 'prop-types'

import withRouter from 'Pods/Shared/withRouter'

import JobAlerts from './Components/JobAlerts'
import JobListFilters from './Components/JobListFilters'
import JobListItem from './Components/JobListItem'
import WildcatBanner from '../../../Shared/Banner/WildcatBanner'
import ListLoader from '../../../Shared/ListLoader'
import Loader from '../../../Shared/Loader'
import EmptyAboutSection from '../Components/EmptyAboutSection'
import EmptyBuyerSection from '../Components/EmptyBuyerSection'
import EmptyDesignerSection from '../Components/EmptyDesignerSection'
import EmptyResults from '../Components/EmptyResults'

class JobsList extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      filters: this.getPreferredFilters(),
      data: [],
      meta: {
        page: 1,
        perPage: 10,
        totalPages: 1,
        isEmpty: {
          pending: true,
          inProgress: true,
          archive: true,
        },
        updatesCount: {
          pending: 0,
          inProgress: 0,
          archive: 0,
        },
      },
      isDataFetched: false,
      resetData: true,
    }

    this.onSearchSubmit = this.onSearchSubmit.bind(this)
    this.onTermChange = this.onTermChange.bind(this)
    this.onFetchFailure = this.onFetchFailure.bind(this)
    this.onFiltersChange = this.onFiltersChange.bind(this)
    this.onSortingChange = this.onSortingChange.bind(this)
    this.handlePageChange = this.handlePageChange.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    const newState = this.state

    newState.filters.perspective = nextProps.perspective
    newState.filters.tab = nextProps.match.params.tab || nextProps.tab
    newState.filters.page = 1
    newState.resetData = true

    this.setPreferredFilters(newState.filters)
    this.setState({ ...newState }, this.fetchData)
  }

  componentDidMount() {
    this.cancelSource = axios.CancelToken.source()
    this.fetchData()
  }

  componentWillUnmount() {
    this.cancelSource.cancel()
  }

  getDefaultFilters() {
    return {
      perspective: this.props.perspective,
      tab: this.props.match.params.tab || this.props.tab,
      page: 1,
      perPage: 10,
      sortBy: 'deadline',
      term: '',
      type: [],
      status: [],
    }
  }

  getPreferredFilters() {
    let filters = {}

    try {
      filters = JSON.parse(sessionStorage.getItem('profile/projects/filters')) || {}
    } catch (_e) {
    }

    return { ...this.getDefaultFilters(), ...filters }
  }

  setPreferredFilters(filters) {
    sessionStorage.setItem('profile/projects/filters', JSON.stringify(filters))
  }

  fetchData(
    filters = { ...this.state.filters },
    resetData = this.state.resetData
  ) {
    axios.get('/api/internal/jobs', {
      params: filters,
      cancelToken: this.cancelSource.token,
    })
      .then((response) => this.onFetchSuccess(response, resetData))
      .catch(this.onFetchFailure)
  }

  onFetchSuccess(response, resetData) {
    this.setState(prevState => ({
      data: resetData ? response.data.data : prevState.data.concat(response.data.data),
      meta: response.data.meta,
      isDataFetched: true,
    }))
  }

  onFetchFailure() {
    this.setState({ isDataFetched: true })
    App.events.publish('app:notification:flash:error', 'Error')
  }

  onTabClick(id) {
    const newState = this.state

    newState.filters.tab = id
    newState.filters.page = 1
    newState.isDataFetched = false
    newState.resetData = true

    this.setPreferredFilters(newState.filters)
    this.props.history.push(`/profile/projects/${newState.filters.tab}`)
    this.setState({ ...newState }, this.fetchData)
  }

  onTermChange(term) {
    const newState = this.state

    newState.filters.term = term.target.value

    this.setPreferredFilters(newState.filters)
    this.setState({ ...newState })
  }

  onSearchSubmit(event) {
    event.preventDefault()

    this.fetchData({ ...this.state.filters, page: 1 }, true)
  }

  onFiltersChange(newFilters) {
    newFilters = newFilters || this.state.filters
    newFilters.page = 1

    this.setPreferredFilters(newFilters)
    this.setState({ filters: newFilters, isDataFetched: false })
    this.fetchData({ ...newFilters }, true)
  }

  onSortingChange(sort) {
    const newState = this.state

    newState.filters.sortBy = sort.value
    newState.filters.page = 1
    newState.resetData = true

    this.setPreferredFilters(newState.filters)
    this.setState({ ...newState }, this.fetchData)
  }

  handlePageChange(pageNumber) {
    const newState = this.state

    newState.filters.page = pageNumber
    newState.resetData = false

    this.setState({ ...newState }, this.fetchData)
  }

  render() {
    const tabs = [
      { title: 'Pending', id: 'pending' },
      { title: 'In progress', id: 'inProgress' },
      { title: 'Archive', id: 'archive' },
    ]

    const typeFilters = [
      { label: 'Public', value: 'public' },
      { label: 'Private', value: 'private' },
    ]

    const statusFilters = [
      { label: 'Finished', value: 'finished' },
      { label: 'Expired', value: 'expired' },
      { label: 'Withdrawn', value: 'withdrawn' },
      { label: 'Canceled', value: 'canceled' },
    ]

    const sorting = [{
      label: 'Deadline (ending soonest first)',
      value: 'deadline',
    }, {
      label: 'Highest budget',
      value: 'budget',
    }, {
      label: 'Fewest applicants',
      value: 'applicants',
    }]

    const activeTab = tabs.filter(tab => tab.id === this.state.filters.tab)

    const emptyTabTitle = `You have no <span className="text-capitalize text-semibold">${activeTab[0].title}</span> 3D Projects`

    const emptyTabButtons = this.props.perspective === 'applied' ? (
      <Fragment>
        <a href="/3d-modeling-jobs/new/invite-client?meta_source=projects_dashboard" className="btn btn-outline-default btn-white">Invite a Client!</a>
        <a href="/3d-modeling-jobs/browse" className="btn btn-primary">Browse Projects</a>
      </Fragment>
    ) : (
      <a href="/3d-modeling-jobs/new?meta_source=projects_dashboard" className="btn btn-primary">Start a Project!</a>
    )

    return (
      <div className="jobs-list-page">
        <div className="container-fixed">
          <ul className="nav-tabs nav-tabs--bordered-small">
            {tabs.map((tab) => {
              return (
                <li key={`tab-head-${tab.id}`} className={tab.id === this.state.filters.tab ? 'is-active' : ''}>
                  <a data-name={tab.id} onClick={() => { this.onTabClick(tab.id) }}>
                    {tab.title}
                    {this.state.meta.updatesCount[tab.id] > 0 && <span className="u-ml10 indicator indicator--square">{this.state.meta.updatesCount[tab.id]}</span>}
                  </a>
                </li>
              )
            })}
          </ul>
          {((this.state.filters.tab === 'pending' && !this.state.meta.isEmpty.pending) || this.state.filters.tab !== 'pending') && (
            <JobListFilters
              onSearchSubmit={this.onSearchSubmit}
              filters={this.state.filters}
              onTermChange={this.onTermChange}
              filterTypeOptions={typeFilters}
              filterStatusOptions={statusFilters}
              onFiltersChange={this.onFiltersChange}
              sortOptions={sorting}
              onSortChange={this.onSortingChange}
            />
          )}
        </div>

        <div className="tabs-content">
          <div className="tab-pane">
            {this.state.isDataFetched ? (
              this.state.data.length > 0 ? (
                <div className="container-fixed">
                  <JobAlerts />

                  <div className="row">
                    {this.state.data.map(job => (
                      <div key={job.id} className="col-xs-12 col-sm-6 col-md-12">
                        <Link to={{ pathname: `/profile/projects/${job.attributes.slug}` }} className="card card--interactive job-list-item">
                          <JobListItem key={job.id} id={job.id} {...job.attributes} tab={this.state.filters.tab} />
                        </Link>
                      </div>
                    ))}
                  </div>

                  <div className="u-text-center">
                    <ListLoader
                      totalPages={this.state.meta.totalPages}
                      currentPage={Number(this.state.meta.page)}
                      onShowMore={this.handlePageChange}
                      buttonClass="btn btn-primary"
                    />
                  </div>

                  {this.props.perspective === 'applied' && this.state.filters.tab === 'pending' && (
                    <WildcatBanner pageName="projects-pending-tab" />
                  )}
                </div>
              ) : (
                this.state.meta.isEmpty.pending && this.state.filters.tab === 'pending' ? (
                  <EmptyResults title={emptyTabTitle} icon="plane-departure" buttons={emptyTabButtons}>
                    <EmptyAboutSection isDesigner={this.props.perspective === 'applied'} />

                    {this.props.perspective === 'applied'
                      ? <EmptyDesignerSection title="Why CGTrader?" /> : <EmptyBuyerSection title="Why CGTrader?" />
                    }
                  </EmptyResults>
                ) : (
                  this.state.filters.term === '' && this.state.filters.type.length === 0 ? (
                    <EmptyResults title={emptyTabTitle} icon="plane-departure" />
                  ) : (
                    <EmptyResults title="No 3D Projects found" icon="search" />
                  )
                )
              )
            ) : (
              <Loader />
            )}
          </div>
        </div>
      </div>
    )
  }
}

JobsList.propTypes = {
  perspective: PropTypes.string.isRequired,
}

export default withRouter(JobsList)
